/**
 * Search Thunks
 *
 * Async thunks for destination search operations
 */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { type DestinationSuggestion } from '@contracts';
import { fetchAutoSuggest as fetchAutoSuggestApi } from '../api/searchApi';
import { handleThunkError } from './thunkUtils';

// ============================================
// Thunks
// ============================================

/**
 * Search destinations (auto-suggest)
 */
export const searchDestinationsThunk = createAsyncThunk<
  DestinationSuggestion[],
  string,
  { rejectValue: string }
>('onboarding/searchDestinations', async (query, { rejectWithValue }) => {
  try {
    const suggestions = await fetchAutoSuggestApi(query);
    return suggestions;
  } catch (error) {
    return rejectWithValue(
      handleThunkError(
        error,
        'fetch destination suggestions',
        'Failed to fetch destination suggestions',
      ),
    );
  }
});
